/**
 * LoginView - Gere o acesso de utilizadores existentes ligando ao Backend Rust no Render.
 */
import { apiFetch } from '../api.js';

export const LoginView = {
    render: async () => {
        return `
            <div class="auth-container animate-fade-in" style="max-width: 400px; margin: 4rem auto; padding: 2rem; background: white; border-radius: 1rem; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
                <div style="text-align: center; margin-bottom: 2rem;">
                    <h2 style="font-size: 1.5rem; font-weight: 700; color: #1e293b;">Bem-vindo ao HeyWeb</h2>
                    <p style="color: #64748b;">Introduz os teus dados para entrar.</p>
                </div>

                <form id="login-form" style="display: flex; flex-direction: column; gap: 1.25rem;">
                    <div class="form-group">
                        <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #475569; margin-bottom: 0.5rem;">E-mail</label>
                        <input type="email" id="login-email" required placeholder="exemplo@email.com" 
                               style="width: 100%; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; outline: none;">
                    </div>

                    <div class="form-group">
                        <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #475569; margin-bottom: 0.5rem;">Palavra-passe</label>
                        <input type="password" id="login-password" required placeholder="••••••••" 
                               style="width: 100%; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; outline: none;">
                    </div>

                    <button type="submit" id="btn-login" 
                            style="width: 100%; background: #3b82f6; color: white; padding: 0.75rem; border: none; border-radius: 0.5rem; font-weight: 600; cursor: pointer; transition: background 0.2s;">
                        Entrar
                    </button>
                </form>

                <div id="login-message" style="margin-top: 1rem; text-align: center; font-size: 0.875rem;"></div>

                <div style="margin-top: 2rem; text-align: center; border-top: 1px solid #e2e8f0; padding-top: 1.5rem;">
                    <p style="font-size: 0.875rem; color: #64748b;">Ainda não tens conta? <a href="#register" style="color: #3b82f6; text-decoration: none; font-weight: 600;">Regista-te aqui</a></p>
                </div>
            </div>
        `;
    },

    afterRender: async () => {
        const form = document.getElementById('login-form');
        const messageDiv = document.getElementById('login-message');

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const credentials = {
                email: document.getElementById('login-email').value,
                password: document.getElementById('login-password').value
            };

            const btn = document.getElementById('btn-login');
            btn.disabled = true;
            btn.innerText = 'A verificar...';

            try {
                // Utilizando o apiFetch centralizado que aponta para https://siteeiro-api.onrender.com
                const response = await apiFetch('/auth/login', {
                    method: 'POST',
                    body: JSON.stringify(credentials)
                });

                if (response.ok) {
                    const data = await response.json();

                    // IMPORTANTE: Guardar o token JWT e o nome do utilizador para a sessão
                    localStorage.setItem('heyweb_token', data.token);
                    localStorage.setItem('user_name', data.user_name || data.name || '');
                    localStorage.setItem('user_email', data.email || credentials.email);

                    messageDiv.style.color = '#166534';
                    messageDiv.innerText = `Olá, ${data.user_name || data.name || credentials.email}! A entrar...`;

                    // Pequeno delay para feedback visual antes de ir para o Dashboard
                    setTimeout(() => window.location.hash = '#dashboard', 1500);
                } else {
                    messageDiv.style.color = '#991b1b';
                    messageDiv.innerText = '❌ E-mail ou palavra-passe incorretos.';
                    btn.disabled = false;
                    btn.innerText = 'Entrar';
                }

            } catch (error) {
                messageDiv.style.color = '#991b1b';
                messageDiv.innerText = '❌ Erro de ligação ao servidor em Frankfurt.';
                btn.disabled = false;
                btn.innerText = 'Entrar';
            }
        });
    }
};
